/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShopPerformance } from './ShopPerformance';
import {
    ShopPerformanceFromJSON,
    ShopPerformanceFromJSONTyped,
    ShopPerformanceToJSON,
    ShopPerformanceToJSONTyped,
} from './ShopPerformance';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface PeriodComparisonData
 */
export interface PeriodComparisonData {
    /**
     * 
     * @type {ShopPerformance}
     * @memberof PeriodComparisonData
     */
    current?: ShopPerformance;
    /**
     * 
     * @type {ShopPerformance}
     * @memberof PeriodComparisonData
     */
    previous?: ShopPerformance;
    /**
     * 
     * @type {ShopPerformance}
     * @memberof PeriodComparisonData
     */
    previousYear?: ShopPerformance;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof PeriodComparisonData
     */
    currentSnapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof PeriodComparisonData
     */
    previousSnapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof PeriodComparisonData
     */
    previousYearSnapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the PeriodComparisonData interface.
 */
export function instanceOfPeriodComparisonData(value: object): value is PeriodComparisonData {
    return true;
}

export function PeriodComparisonDataFromJSON(json: any): PeriodComparisonData {
    return PeriodComparisonDataFromJSONTyped(json, false);
}

export function PeriodComparisonDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PeriodComparisonData {
    if (json == null) {
        return json;
    }
    return {
        
        'current': json['current'] == null ? undefined : ShopPerformanceFromJSON(json['current']),
        'previous': json['previous'] == null ? undefined : ShopPerformanceFromJSON(json['previous']),
        'previousYear': json['previousYear'] == null ? undefined : ShopPerformanceFromJSON(json['previousYear']),
        'currentSnapshot': json['currentSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['currentSnapshot']),
        'previousSnapshot': json['previousSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['previousSnapshot']),
        'previousYearSnapshot': json['previousYearSnapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['previousYearSnapshot']),
    };
}

export function PeriodComparisonDataToJSON(json: any): PeriodComparisonData {
    return PeriodComparisonDataToJSONTyped(json, false);
}

export function PeriodComparisonDataToJSONTyped(value?: PeriodComparisonData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current': ShopPerformanceToJSON(value['current']),
        'previous': ShopPerformanceToJSON(value['previous']),
        'previousYear': ShopPerformanceToJSON(value['previousYear']),
        'currentSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['currentSnapshot']),
        'previousSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousSnapshot']),
        'previousYearSnapshot': PrecalculationSnapshotReadMetadataToJSON(value['previousYearSnapshot']),
    };
}

